import { css } from '@emotion/css';

import { fluidValues, fontStyle } from '@/css/resources/mixins.css';
import {
	breakpoints,
	fontFamilies,
	fontWeights,
	colors,
} from '@/css/resources/variables.css';
import { grid } from '@/css/resources/placeholders.css';
import { cssObj } from '@/css/resources/functions.css';

export const getStyles = (titleColor = '#E4061E', font = null) =>
	css(
		fluidValues('marginTop', 100, 150, true),
		fluidValues('paddingBlock', 100, 150, true),
		{
			backgroundColor: colors.brand1Base,
			'.supt-section__inner': cssObj(grid, {
				rowGap: 40,
			}),
			'.supt-section__headline': {
				gridRow: 1,
				gridColumnStart: '1',
				gridColumnEnd: `span 12`,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',

				a: {
					textDecoration: 'none',
					color: 'inherit',
				},

				figure: {
					display: 'inline-flex',
					img: cssObj(fluidValues('height', 200, 300, true), {
						maxWidth: '100%',
						width: 'auto',
						height: 'auto',
						objectFit: 'contain',
						objectPosition: 'center',
					}),

					'+ .supt-section__title': {
						position: 'absolute',
						zIndex: -10,
						opacity: 0,
						userSelect: 'none',
					},
				},
			},

			'.supt-section__title': cssObj(
				fontStyle({
					fontFamily: font?.name
						? `"${font?.name}"`
						: fontFamilies.primary,
					fontWeight: fontWeights.medium,
					fontSize: [
						font?.mobileSize ?? 66,
						font?.desktopSize ?? 110,
					],
					textTransform: font?.name ? 'initial' : 'uppercase',
					color: titleColor,
					textAlign: 'center',
				}),
				{
					lineHeight: 0.83,
					letterSpacing: 0,
				}
			),

			'.supt-section__buttons': {
				gridColumn: '1/ span 12',

				[`@media (min-width: ${breakpoints.medium})`]: {
					gridRow: 1,
					gridColumn: '9/ span 4',
					marginTop: 0,
					display: 'flex',
					justifyContent: 'flex-end',
					alignItems: 'flex-end',
				},
				[`@media (min-width: ${breakpoints.bigLaptop})`]: {
					gridColumn: '7/ span 6',
				},

				'.supt-listCards': {
					margin: 0,
				},
			},

			'.supt-section__content': cssObj({
				gridColumn: '1/ span 12',
			}),

			// Don't apply the negative margin-top on next section to avoid overlapping
			'& + .supt-section': {
				marginTop: '0 !important',
			},
		}
	);
